import {isEmpty} from 'lodash';

const store = {};

export const keys = {
  ALL_REHAB_VIDEOS: Symbol(),
};

export function has(key) {
  return store.hasOwnProperty(key);
}

export function get(key) {
  return store[key];
}

export function set(key, value) {
  store[key] = value;
}

export async function retries(key, cb) {
  if (has(key)) {
    return get(key);
  }

  const data = typeof cb === 'function' ? await getReturnData(cb) : cb;

  set(key, data);

  return data;
}

async function getReturnData(fn) {
  try {
    const result = fn();

    if (result instanceof Promise) {
      return await result;

    } else {
      return result;
    }
  } catch (error) {
    throw error;
  }
}
